import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import item1 from "../../assets/images/04_img_1.png"
import item2 from "../../assets/images/04_img_2.png"
import item3 from "../../assets/images/04_img_3.png"
import item4 from "../../assets/images/04_img_4.jpg"
import MainList from "../../components/organisms/MainList";

const Notice = () => {
    const noticeList = [
        {
            id: 1,
            title: "공지",
            img: item1,
            link: "/notice/announcement"
        },
        {
            id: 2,
            title: "캠페인",
            img: item2,
            link: "/notice/campaign"
        },
        {
            id: 3,
            title: "강아지숲 이야기",
            img: item3,
            link: "/notice/dstory"
        },
        {
            id: 4,
            title: "자주하는 질문",
            img: item4,
            link: "/notice/faq"
        },
    ];
    return (
        <>
            <PageHeader
                detail="알림"
                desc="강아지숲의 다양한 정보를 전달해 드립니다."
            />
            <MainList
                list={noticeList}
                pagination={false}
            />
        </>
    );
};

export default Notice;
